(ns quuppa.peweb.http
  "Sets up Re-frame http-effect"
  (:require [ajax.core :as ajax]
            [quuppa.common.transit :as q-transit]
            [re-chain.core :as chain]
            day8.re-frame.http-fx))

(def ?csrf-token
  (when-let [el (.getElementById js/document "sente-csrf-token")]
    (.getAttribute el "data-csrf-token")))

(defn local-uri? [{:keys [uri]}]
  (not (re-find #"^\w+?://" uri)))

(defn default-headers [request]
  (if (local-uri? request)
    (-> request
        (update :headers #(merge {"x-csrf-token" ?csrf-token} %)))
    request))

;; injects transit serialization config into request options
;; TODO: What is this, not being used anywhere.
; (defn as-transit [opts]
;   (merge {:raw             false
;           :format          :transit
;           :response-format :transit
;           :reader          (transit/reader :json q-transit/read-handlers)
;           :writer          (transit/writer :json q-transit/write-handlers)}
;          opts))

(defn json-request-format []
  (ajax/json-request-format))

(defn json-response-format []
  (ajax/json-response-format {:keywords? true}))

(defn transit-request-format []
  (ajax/transit-request-format {:type :json-verbose
                                :handlers q-transit/write-handlers}))

(defn transit-response-format []
  (ajax/transit-response-format {:type :json
                                 :handlers q-transit/read-handlers}))

(def blank-response ajax/text-response-format)

(defn configure-http-fx! []
  (swap! ajax/default-interceptors
         conj
         (ajax/to-interceptor {:name "default headers"
                               :request default-headers})))

;; TODO: Remove re-chain
(chain/configure!
  ;; http-fx
  [{:effect-present? (fn [effects] (:http-xhrio effects))
    :get-dispatch (fn [effects] (get-in effects [:http-xhrio :on-success]))
    :set-dispatch (fn [effects dispatch] (assoc-in effects [:http-xhrio :on-success] dispatch))}])
